// composables/useChatMessages.js
import { chatStateManager } from '../lib/chatStateManager'

export function useChatMessages() {
  
  const addMessage = (messageData) => {
    const message = {
      id: messageData.id || Date.now() + Math.random(),
      timestamp: new Date(),
      ...messageData
    };
    
    console.log('➕ Adding message to state manager:', message);
    chatStateManager.addMessage(message);
    
    return message;
  };

  const removeTypingMessage = () => {
    console.log('🗑️ Removing typing message...');
    chatStateManager.removeTypingMessage();
  };

  const addCustomerMessage = (content) => {
    return addMessage({
      type: 'customer',
      content: content
    });
  };

  const addAIMessage = (content, agentInfo = null) => {
    return addMessage({
      type: 'ai',
      content: content,
      agentInfo: agentInfo
    });
  };

  const addAgentMessage = (content, agentInfo = null) => {
    return addMessage({
      type: 'agent',
      content: content,
      agentInfo: agentInfo
    });
  };

  const addSystemMessage = (content) => {
    return addMessage({
      type: 'system',
      content: content
    });
  };

  const addAgentJoinedMessage = (agentData) => {
    return addMessage({
      type: 'agent-joined',
      content: `${agentData.agentInfo.agentName || 'Ein Mitarbeiter'} ist dem Chat beigetreten`,
      subtitle: 'Sie können jetzt direkt mit unserem Team sprechen',
      agentInfo: agentData.agentInfo
    });
  };

  return {
    addMessage,
    removeTypingMessage,
    addTypingIndicator: () => chatStateManager.addTypingIndicator(),
    clearTemporaryMessages: () => chatStateManager.clearTemporaryMessages(),
    addCustomerMessage,
    addAIMessage,
    addAgentMessage,
    addSystemMessage,
    addAgentJoinedMessage
  };
}
